import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { deleteSize, getSizeById } from "../../../api/sizeService";
import { getErrorMessage } from "../../../utils/errorHandler";
import StatusBadge from "../../Shared/StatusBadge";
import RecordActions from "../../Shared/RecordActions";
import FullPageLoader from "../../../common/FullPageLoader";

export default function ViewSize() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: routeId } = useParams();
  const id = location?.state?.sizeId || routeId;

  const [size, setSize] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSize = async () => {
    try {
      setLoading(true);

      const response = await getSizeById(id);

      setSize(response?.data || response);
    } catch (error) {
      console.error("Error fetching size:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchSize();
    }
  }, [id]);

  if (loading) {
    return <FullPageLoader text="Loading size..." />;
  }

  if (!size) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Size not found
          </div>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this size?")) return;

    try {
      await deleteSize(id);
      navigate("/size");
    } catch (error) {
      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4">
        <div className="card p-3 d-flex justify-content-between">
          <RecordActions
            onBack={() => navigate("/size")}
            onEdit={() =>
              navigate(`/size/edit/${size.name}`, {
                state: { sizeId: id },
              })
            }
            onDelete={handleDelete}
          />

          <div className="row g-3">
            <div className="col-md-4">
              <span className="fw-bold">Size Name : </span>
              
                {size.name || "N/A"}
            
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Size Value : </span>
                {size.value || "N/A"}
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Status : </span>
                <StatusBadge status={size.status} />
            </div>
          </div>
        </div>
    </div>
  );
}
